"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceSansPro = void 0;
/**
 * Copyright © 2021 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const source_sans_pro_200_woff_1 = __importDefault(require("../fonts/source-sans-pro-200.woff"));
const source_sans_pro_200_woff2_1 = __importDefault(require("../fonts/source-sans-pro-200.woff2"));
const source_sans_pro_200italic_woff_1 = __importDefault(require("../fonts/source-sans-pro-200italic.woff"));
const source_sans_pro_200italic_woff2_1 = __importDefault(require("../fonts/source-sans-pro-200italic.woff2"));
const source_sans_pro_300_woff_1 = __importDefault(require("../fonts/source-sans-pro-300.woff"));
const source_sans_pro_300_woff2_1 = __importDefault(require("../fonts/source-sans-pro-300.woff2"));
const source_sans_pro_300italic_woff_1 = __importDefault(require("../fonts/source-sans-pro-300italic.woff"));
const source_sans_pro_300italic_woff2_1 = __importDefault(require("../fonts/source-sans-pro-300italic.woff2"));
const source_sans_pro_regular_woff_1 = __importDefault(require("../fonts/source-sans-pro-regular.woff"));
const source_sans_pro_regular_woff2_1 = __importDefault(require("../fonts/source-sans-pro-regular.woff2"));
const source_sans_pro_italic_woff_1 = __importDefault(require("../fonts/source-sans-pro-italic.woff"));
const source_sans_pro_italic_woff2_1 = __importDefault(require("../fonts/source-sans-pro-italic.woff2"));
const source_sans_pro_600_woff_1 = __importDefault(require("../fonts/source-sans-pro-600.woff"));
const source_sans_pro_600_woff2_1 = __importDefault(require("../fonts/source-sans-pro-600.woff2"));
const source_sans_pro_600italic_woff_1 = __importDefault(require("../fonts/source-sans-pro-600italic.woff"));
const source_sans_pro_600italic_woff2_1 = __importDefault(require("../fonts/source-sans-pro-600italic.woff2"));
const source_sans_pro_700_woff_1 = __importDefault(require("../fonts/source-sans-pro-700.woff"));
const source_sans_pro_700_woff2_1 = __importDefault(require("../fonts/source-sans-pro-700.woff2"));
const source_sans_pro_700italic_woff_1 = __importDefault(require("../fonts/source-sans-pro-700italic.woff"));
const source_sans_pro_700italic_woff2_1 = __importDefault(require("../fonts/source-sans-pro-700italic.woff2"));
const source_sans_pro_900_woff_1 = __importDefault(require("../fonts/source-sans-pro-900.woff"));
const source_sans_pro_900_woff2_1 = __importDefault(require("../fonts/source-sans-pro-900.woff2"));
const source_sans_pro_900italic_woff_1 = __importDefault(require("../fonts/source-sans-pro-900italic.woff"));
const source_sans_pro_900italic_woff2_1 = __importDefault(require("../fonts/source-sans-pro-900italic.woff2"));
exports.sourceSansPro = `
/* source-sans-pro-200 - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 200;
  src: local(''),
       url(${source_sans_pro_200_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_200_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-200italic - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 200;
  src: local(''),
       url(${source_sans_pro_200italic_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_200italic_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-300 - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 300;
  src: local(''),
       url(${source_sans_pro_300_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_300_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-300italic - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 300;
  src: local(''),
       url(${source_sans_pro_300italic_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_300italic_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-regular - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  src: local(''),
       url(${source_sans_pro_regular_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_regular_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-italic - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 400;
  src: local(''),
       url(${source_sans_pro_italic_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_italic_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-600italic - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 600;
  src: local(''),
       url(${source_sans_pro_600italic_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_600italic_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-600 - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  src: local(''),
       url(${source_sans_pro_600_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_600_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-700 - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;
  src: local(''),
       url(${source_sans_pro_700_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_700_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-700italic - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 700;
  src: local(''),
       url(${source_sans_pro_700italic_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_700italic_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-900 - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 900;
  src: local(''),
       url(${source_sans_pro_900_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_900_woff_1.default}) format('woff'); /* Modern Browsers */
}
/* source-sans-pro-900italic - vietnamese_latin-ext_latin_greek-ext_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 900;
  src: local(''),
       url(${source_sans_pro_900italic_woff2_1.default}) format('woff2'), /* Super Modern Browsers */
       url(${source_sans_pro_900italic_woff_1.default}) format('woff'); /* Modern Browsers */
}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1mb250cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvZGVmYXVsdC1mb250cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7Ozs7O0dBTUc7QUFDSCxpR0FBMkU7QUFDM0UsbUdBQTZFO0FBQzdFLDZHQUFpRjtBQUNqRiwrR0FBbUY7QUFDbkYsaUdBQTJFO0FBQzNFLG1HQUE2RTtBQUM3RSw2R0FBaUY7QUFDakYsK0dBQW1GO0FBQ25GLHlHQUE0RTtBQUM1RSwyR0FBOEU7QUFDOUUsdUdBQTJFO0FBQzNFLHlHQUE2RTtBQUM3RSxpR0FBMkU7QUFDM0UsbUdBQTZFO0FBQzdFLDZHQUFpRjtBQUNqRiwrR0FBbUY7QUFDbkYsaUdBQTJFO0FBQzNFLG1HQUE2RTtBQUM3RSw2R0FBaUY7QUFDakYsK0dBQW1GO0FBQ25GLGlHQUEyRTtBQUMzRSxtR0FBNkU7QUFDN0UsNkdBQWlGO0FBQ2pGLCtHQUFtRjtBQUV0RSxRQUFBLGFBQWEsR0FBRzs7Ozs7OzthQU9oQixtQ0FBMkI7YUFDM0Isa0NBQTBCOzs7Ozs7OzthQVExQix5Q0FBMkI7YUFDM0Isd0NBQTBCOzs7Ozs7OzthQVExQixtQ0FBMkI7YUFDM0Isa0NBQTBCOzs7Ozs7OzthQVExQix5Q0FBMkI7YUFDM0Isd0NBQTBCOzs7Ozs7OzthQVExQix1Q0FBd0I7YUFDeEIsc0NBQXVCOzs7Ozs7OzthQVF2QixzQ0FBd0I7YUFDeEIscUNBQXVCOzs7Ozs7OzthQVF2Qix5Q0FBMkI7YUFDM0Isd0NBQTBCOzs7Ozs7OzthQVExQixtQ0FBMkI7YUFDM0Isa0NBQTBCOzs7Ozs7OzthQVExQixtQ0FBMkI7YUFDM0Isa0NBQTBCOzs7Ozs7OzthQVExQix5Q0FBMkI7YUFDM0Isd0NBQTBCOzs7Ozs7OzthQVExQixtQ0FBMkI7YUFDM0Isa0NBQTBCOzs7Ozs7OzthQVExQix5Q0FBMkI7YUFDM0Isd0NBQTBCOztDQUV0QyxDQUFDIn0=